import { render, staticRenderFns } from "./InputBasico.vue?vue&type=template&id=3c4103b4&"
import script from "./InputBasico.vue?vue&type=script&lang=js&"
export * from "./InputBasico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports